import { EmptyState } from "@/components/admin/EmptyState";
import type { MediaItem } from "@/features/media/types";
import { MediaCard } from "./MediaCard";

interface MediaGridProps {
  items: MediaItem[];
  isLoading?: boolean;
  selectedIds?: string[];
  canDelete?: boolean;
  onSelect?: (item: MediaItem) => void;
  onEdit?: (item: MediaItem) => void;
  onDelete?: (item: MediaItem) => void;
}

export function MediaGrid({ items, isLoading, selectedIds = [], canDelete, onSelect, onEdit, onDelete }: MediaGridProps) {
  if (items.length === 0) {
    return <EmptyState title={isLoading ? "Loading media..." : "No media found"} description="Upload images or adjust your search." />;
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((item) => (
        <MediaCard
          key={item.id}
          item={item}
          selected={selectedIds.includes(item.id)}
          canDelete={canDelete}
          onSelect={onSelect}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
